import styled from "styled-components";

export const RiskLabel = styled.div`
  margin: 6px 0;
  display: flex;
  justify-content: space-between;
  width: 185px;
`;

export const RiskText = styled.div`
  color: ${props => props.theme.fontColors.textColor};
  font-size: ${props => props.theme.fontSize.tertiary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.normal};
  text-align: left;
  letter-spacing: ${props => props.theme.letterSpacing.zero};
`;

export const RiskTextNext = styled.div`  
  color: ${props => props.theme.fontColors.textColor};
  font-size: ${props => props.theme.fontSize.tertiary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.normal};
  text-align: left;
  letter-spacing: ${props => props.theme.letterSpacing.zero};
`;

export const ContainerDiv = styled.div`
  height: 40px;
  width: 160px;
  display: flex;
  align-items: flex-end;
`;

export const ClipDiv1 = styled.div`
  width: 25px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  height: ${props => (props.color !== -1 ? "24px" : "16px")};
  background-color: ${props => (props.color !== -1 ? props.color : props.theme.backgroundColor.summaryDivider)};
  color: ${props => (props.color !== -1 ?  props.theme.fontColors.white :  props.theme.fontColors.textColor)};
  font-size: ${props => props.theme.fontSize.tertiary};
  -webkit-clip-path: polygon(0 15%, 100% 0, 100% 100%, 0% 100%);
  clip-path: polygon(0 15%, 100% 0, 100% 100%, 0% 100%);
  margin-right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ClipDiv2 = styled.div`
  width: 25px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  height: ${props => (props.color !== -1 ? "27px" : "19px")};
  background-color: ${props => (props.color !== -1 ? props.color : props.theme.backgroundColor.summaryDivider)};
  color: ${props => (props.color !== -1 ?  props.theme.fontColors.white :  props.theme.fontColors.textColor)};
  font-size: ${props => props.theme.fontSize.tertiary};
  -webkit-clip-path: polygon(0 15%, 100% 0, 100% 100%, 0% 100%);
  clip-path: polygon(0 15%, 100% 0, 100% 100%, 0% 100%);
  margin-right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ClipDiv3 = styled.div`
  width: 25px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  height: ${props => (props.color !== -1 ? "30px" : "22px")};
  background-color: ${props => (props.color !== -1 ? props.color : props.theme.backgroundColor.summaryDivider)};
  color: ${props => (props.color !== -1 ?  props.theme.fontColors.white :  props.theme.fontColors.textColor)};
  font-size: ${props => props.theme.fontSize.tertiary};
  -webkit-clip-path: polygon(0 15%, 100% 0, 100% 100%, 0% 100%);
  clip-path: polygon(0 15%, 100% 0, 100% 100%, 0% 100%);
  margin-right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ClipDiv4 = styled.div`
  width: 25px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  height: ${props => (props.color !== -1 ? "34px" : "26px")};
  background-color: ${props => (props.color !== -1 ? props.color : props.theme.backgroundColor.summaryDivider)};
  color: ${props => (props.color !== -1 ?  props.theme.fontColors.white :  props.theme.fontColors.textColor)};
  font-size: ${props => props.theme.fontSize.tertiary};
  -webkit-clip-path: polygon(0 15%, 100% 0, 100% 100%, 0% 100%);
  clip-path: polygon(0 15%, 100% 0, 100% 100%, 0% 100%);
  margin-right: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ClipDiv5 = styled.div`
  width: 25px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  height: ${props => (props.color !== -1 ? "38px" : "30px")};
  background-color: ${props => (props.color !== -1 ? props.color : props.theme.backgroundColor.summaryDivider)};
  color: ${props => (props.color !== -1 ?  props.theme.fontColors.white :  props.theme.fontColors.textColor)};
  font-size: ${props => props.theme.fontSize.tertiary};
  -webkit-clip-path: polygon(0 15%, 100% 0, 100% 100%, 0% 100%);
  clip-path: polygon(0 15%, 100% 0, 100% 100%, 0% 100%);
  display: flex;
  align-items: center;
  justify-content: center;
`;
